import { faPenToSquare, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Flex, message, Modal, Row } from "antd";
import React, { useState } from "react";
import { Container } from "react-bootstrap";

import { DeleteFilled } from "@ant-design/icons";
import { ExclamationCircleFilled } from "@ant-design/icons";

import "./Categories.css";
import AddCategory from "./AddCategory";
import {
  useDeleteCategoryMutation,
  useGetAllCategoriesQuery,
} from "../../redux/Service/api";
import Loading from "../../components/utils/Loading";
import EditCategory from "./EditCategory";

const { Meta } = Card;
const { confirm } = Modal;

function Categories() {
  const [openAddModal, setOpenAddModal] = useState(false);

  const [openEditModal, setOpenEditModal] = useState(false);
  const [rerenderEditKey, setRerenderEditKey] = useState(0);
  const [tipIdForEdit, setTipIdForEdit] = useState(null);

  const {
    data: allCategoriessData,
    isError: isAllCategoriesError,
    isLoading: isAllCategoriesLoading,
    error: allCategoriesError,
  } = useGetAllCategoriesQuery();

  const allCategories = allCategoriessData?.data ?? null;

  const [modal, contextHolder] = Modal.useModal();

  const [
    deleteCategory,
    { isLoading: delIsLoading, isError: delIsError, error: delError },
  ] = useDeleteCategoryMutation();

  const handleDeleteCategory = async (id) => {
    confirm({
      title: "Do you really want to delete this product?",
      icon: <ExclamationCircleFilled />,
      content: "When clicked the OK button, this product will be removed ",
      async onOk() {
        try {
          const res = await deleteCategory(id);
          res.data.message
            ? message.info(res.data.message)
            : message.success("product is deleted successfully");
        } catch (error) {
          console.log(error);
        }
      },
      onCancel() {},
    });
  };

  console.log(allCategories);

  return (
    <section className=" section_padding mt-0 pt-0 position-relative">
      <h2 className="main_heading">Products</h2>
      {isAllCategoriesLoading && <Loading />}
      {(isAllCategoriesError || delIsError) && (
        <p className="text-danger">Something went error</p>
      )}
      {contextHolder}
      <Flex gap="small" wrap="nowrap" className="justify-content-center mb-5">
        <Button type="primary" onClick={() => setOpenAddModal(true)}>
          <FontAwesomeIcon icon={faPlus} /> Add Product{" "}
        </Button>
      </Flex>
      <Container className="my-5">
        <Row className="gap-5 justify-content-center">
          {allCategories?.map((category) => (
            <Card
              key={category.id}
              hoverable
              className="cat col-12 col-sm-6 col-md-3 col-lg-3"
              // loading={delIsLoading}
              cover={
                <img
                  alt="slide-icon"
                  className="img_cat"
                  src={category.photo}
                  style={{ maxHeight: "10rem", objectFit: "contain" }}
                />
              }
              actions={[
                <DeleteFilled
                  key="setting"
                  style={{ fontSize: "20px" }}
                  onClick={() => {
                    handleDeleteCategory(category.id);
                  }}
                />,
                // <FontAwesomeIcon
                //   style={{ fontSize: "20px" }}
                //   icon={faPenToSquare}
                //   onClick={() => {
                //     setTipIdForEdit(category.id);
                //     setOpenEditModal(true);
                //     setRerenderEditKey((prev) => prev + 1);
                //   }}
                // />,
              ]}
            >
              <div className=" position-relative text-center">
                {category.details}
              </div>
            </Card>
          ))}
        </Row>

        {/* add product */}
        <AddCategory
          setOpenAddModal={setOpenAddModal}
          openAddModal={openAddModal}
        />

        {/* <EditCategory
          setOpenEditModal={setOpenEditModal}
          openEditModal={openEditModal}
          tipIdForEdit={tipIdForEdit}
          rerenderEditKey={rerenderEditKey}
        /> */}
      </Container>
    </section>
  );
}

export default Categories;
